import { render, staticRenderFns } from "./GlobalSearch_Search.vue?vue&type=template&id=f2b8bba8"
import script from "./GlobalSearch_Search.vue?vue&type=script&lang=js"
export * from "./GlobalSearch_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports